{
  "DATE_PICKER": {
    "PREVIOUS_PERIOD": "Previous period",
    "NEXT_PERIOD": "Next period",
    "WEEK_NUMBER": "Week #{weekNumber}",
    "APPLY_BUTTON": "Terapkan",
    "CLEAR_BUTTON": "Clear",
    "DATE_RANGE_INPUT": {
      "START": "Start Date",
      "END": "End Date"
    },
    "DATE_RANGE_OPTIONS": {
      "TITLE": "DATE RANGE",
      "LAST_7_DAYS": "7 hari terakhir",
      "LAST_30_DAYS": "30 hari terakhir",
      "LAST_3_MONTHS": "3 bulan terakhir",
      "LAST_6_MONTHS": "6 bulan terakhir",
      "LAST_YEAR": "Tahun terakhir",
      "THIS_WEEK": "This week",
      "MONTH_TO_DATE": "This month",
      "CUSTOM_RANGE": "Rentang tanggal kustom"
    }
  }
}
